module.exports = __webpack_public_path__ + "img/border-2--active.2cbe0de8.svg";